import React , {useEffect} from 'react'

const Footer = () => {
    const today = new Date() 
    const year = today.getFullYear()
   
    
  return (
    <div className='flex relative  justify-center w-full dark:text-white gap-6 py-3 bg-white dark:bg-gray-800 items-center'>
        <div className='flex right'>
        <p> تیم طراحی <a className='text-red-400' href="https://sparrowagc.ir/">sparrow</a></p>
        
        </div>
        <div className='flex left '>
        <p>کپی رایت</p>
        <p className='mx-1'>&copy;</p>
        <p>{year.toString()}</p>
        </div>
    </div>
  )
}

export default Footer